import { render, staticRenderFns } from "./CandidateTasks.vue?vue&type=template&id=2f9142ec&scoped=true&lang=pug"
import script from "./CandidateTasks.vue?vue&type=script&lang=ts"
export * from "./CandidateTasks.vue?vue&type=script&lang=ts"
import style0 from "./CandidateTasks.vue?vue&type=style&index=0&id=2f9142ec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9142ec",
  null
  
)

/* custom blocks */
import block0 from "./REmployerCandidateTasks.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FTasks%2FCandidateTasks.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports